import { Property } from "dash-styled"
import upperFirst from "lodash/upperFirst"
import React, { FC, useEffect, useMemo, useRef } from "react"
import {
    fromNow,
    msToFormattedTime
} from "../../../../../../../../Helpers/Functions/dateFormat"
import { sentenceCase } from "../../../../../../../../Helpers/Functions/string"
import { useBoolean } from "../../../../../../../../Hooks/useBoolean"
import {
    APITaskDetailsModel,
    LabelerType
} from "../../../../../../../../Models/API/TaskModel"

import { TaskStatusPill } from "../../../Common/TaskStatusPill"
import { CollapsibleSectionHeader } from "../../../../../../../Common/CollapsibleSectionHeader/CollapsibleSectionHeader"
import { TaskAssigneeView } from "../TaskAssigneeView"

interface TaskDetailsProps {
    appID: string
    taskDetails: APITaskDetailsModel | undefined
    taskNumber: number
}

/**
 * @deprecated
 */
export const TaskDetails: FC<TaskDetailsProps> = ({
    appID,
    taskDetails,
    taskNumber
}: TaskDetailsProps) => {
    const scrollRef = useRef<HTMLDivElement>(null)
    const [areDetailsVisible, , , , setVisibility] = useBoolean(false)
    const isCollaboratorTask = useMemo<boolean>(
        () => taskDetails?.labelerType === LabelerType.collaborator,
        [taskDetails]
    )

    useEffect(() => {
        if (taskDetails === undefined) {
            setVisibility(false)
        }
    }, [setVisibility, taskDetails])

    useEffect(() => {
        if (areDetailsVisible) {
            scrollRef.current?.scrollIntoView({
                behavior: "smooth",
                block: "nearest",
                inline: "start"
            })
        }
    }, [areDetailsVisible])

    return (
        <div data-testid="task-details" ref={scrollRef}>
            <CollapsibleSectionHeader
                testId="task-details-header"
                headerComponent="h2"
                isOpen={areDetailsVisible}
                separator={true}
                onToggle={() => setVisibility(!areDetailsVisible)}
            >
                Task details
            </CollapsibleSectionHeader>
            {areDetailsVisible && taskDetails !== undefined ? (
                <div
                    data-testid="task-details-properties"
                    className="ml-5 mt-2"
                >
                    <Property name="Number">{taskNumber}</Property>
                    <Property name="Type">
                        {upperFirst(sentenceCase(taskDetails.type))}
                    </Property>
                    <Property name="Status">
                        <TaskStatusPill
                            size="sm"
                            status={taskDetails.status}
                            correct={taskDetails.correct}
                        />
                    </Property>
                    <Property name="Assigned to">
                        <TaskAssigneeView appID={appID} model={taskDetails} />
                    </Property>
                    <Property name="Completed">
                        {taskDetails.completed === null ||
                        taskDetails.completed === undefined
                            ? ""
                            : fromNow(taskDetails.completed.toString())}
                    </Property>
                    {isCollaboratorTask ? (
                        <Property name="Processing time">
                            {taskDetails.labelingTime === null ||
                            taskDetails.labelingTime === undefined
                                ? ""
                                : msToFormattedTime(taskDetails.labelingTime)}
                        </Property>
                    ) : null}
                    <Property name="Task ID">{taskDetails.id}</Property>
                </div>
            ) : null}
        </div>
    )
}
